import router from '@/plugins/router'

/**
 * Check whether an API error indicates missing or invalid consent.
 * Works with the plain error objects produced by the Axios response interceptor.
 */
export function isConsentError(error) {
  const message = error?.message || error?.code || ''
  return typeof message === 'string' && message.toLowerCase().includes('consent')
}

/**
 * Clear stale consent state and redirect to the onboarding flow.
 * Accepts the destructured Vuex action context ({ commit }) from within
 * the auth module — commit is already module-scoped.
 */
export function handleConsentError({ commit }) {
  commit('setOnboardingConsent', null)

  const currentPath = router.currentRoute.value?.fullPath
  const redirectUri = currentPath?.startsWith('/auth') ? undefined : currentPath

  router.replace({
    path: '/onboarding',
    query: { authRedirect: redirectUri },
  })
}
